import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'shared/utils/toast';
import TicketForm from '../components/form/TicketForm';
import { ITicket } from '../types';
import { ticketingService } from '../TicketingService';

const initTicket: ITicket = {
  id: null,
  equipment: null,
  description: null,
  status: {
    value: 1,
    display_name: 'OPEN'
  },
  approvation_status: false
};

export const AddTicket = () => {
  const translationPrefix = 'pages.tickets.new';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const equipmentId = searchParams.get('equipmentId');

  const initialFormValues: ITicket = {
    ...initTicket,
    equipment: Number(equipmentId)
  };

  const onSubmit = async (values) => {
    ticketingService.add(values).then((res) => {
      toast.success(t(`${translationPrefix}.success`));
      navigate('../');
    });
  };

  const ticket: ITicket = initialFormValues ? initialFormValues : initTicket;

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <TicketForm ticket={ticket} onSubmit={onSubmit} creation={true} />
    </TenantPage>
  );
};

export default AddTicket;
